<template>
  <div class="home" :class="darkMode ? 'bg-light text-info' : 'bg-dark text-info'" style="padding-top: 90px; padding-bottom: 90px">
    <b-row class="m-0 mt-3 justify-content-center">
      <div style="width: 400px; max-width: 100vw" class="mr-md-5 p-1  showcase-invert" :class="darkMode ? 'bg-white' : 'bg-dark'">
        <div class="showcase-header bg-info text-white">
          <b-row class="m-0 justify-content-center">
            <img v-if="!darkMode" class="p-0" style="width: 280px; height: 60px" src="@/assets/logos/easyShyftLight.png" alt="" @click="$router.push('/home').catch(err => {})"/> 
            <img v-if="darkMode" class="p-0" style="width: 280px; height: 60px" src="@/assets/logos/easyShyftDark.png" alt="" @click="$router.push('/home').catch(err => {})"/>
          </b-row>
        </div>
        <b-row class="m-0 mt-3 justify-content-center text-white">
          <h2  :class="darkMode ? 'text-dark' : 'text-white'">Login</h2>
        </b-row>
        <b-row class="m-0 justify-content-center">
          <div class="pt-3 pb-3 p-2" style="width: 320px;"  :class="darkMode ? 'text-dark' : 'text-white'">
            <b-form @submit.prevent="login" >
              <b-row class="justify-content-center m-0">
                <p v-if="authError" class="text-danger"> {{ authMessage }}</p>
              </b-row>
              <b-form-group
                id="input-group-1"
                label="E-Mail / MA-Nummer:"
                label-for="input-111"
              >
                <b-form-input
                  class="text-center"
                  id="input-111"
                  :state="authError ? false : null"
                  v-model="form.email"
                  required
                  type="text"
                  placeholder="E-Mail / MA-Nummer..."
                ></b-form-input>
              </b-form-group>

              <b-form-group id="input-group-2" label="Passwort:" label-for="input-2">
                <b-form-input
                  class="text-center"
                  id="input-211"
                  required
                  :state="authError ? false : null"
                  v-model="form.password"
                  type="password"
                  placeholder="Passwort eingeben..."
                ></b-form-input>
              </b-form-group>
              <b-row class="justify-content-center m-0">
                <b-link  @click="$router.push({path: '/resetpassword'})">Passwort vergessen?</b-link>
              </b-row>
              <b-row class="justify-content-around mt-3">
                <b-button v-if="!updating" class="btn-custom linear-info text-white" style="width: 45%" type="submit"  :variant="darkMode ? 'light' : 'dark'"  >anmelden</b-button>
                <b-button v-if="updating" class="btn-custom linear-info text-white" style="width: 45%" disabled  :variant="darkMode ? 'light' : 'dark'" ><b-spinner small label="Spinning"></b-spinner></b-button>
              </b-row>

              <b-row class="justify-content-around mt-3">
                <b-form-group class="pt-4">
                  <p><strong>noch keinen Account?</strong></p>
                  <b-button style="width: 200px" class="shadow btn-custom" variant="dark" @click="$router.push({path: '/register'})">jetzt registrieren</b-button>
                </b-form-group>
              </b-row>
              
            </b-form>
          </div>  
        </b-row>
      </div>
    </b-row>
  </div>
</template>

<script>

import coreData from '@/mixins/coreDataMixin'

export default {
  name: 'Login',
  mixins: [coreData],

  components: {

  },
  data: () => {
    return {
      form: {}
    }
  },
  computed: {
    darkMode(){
      return this.$store.getters.darkMode
    }
  },
  mounted(){
    this.$store.commit('updating', false)
  },
  methods: {
    login(){
      var payload = {
        email: this.form.email,
        password: this.form.password
      }
      this.$store.dispatch('login', payload)
    }
  }
}
</script>

<style lang="scss">
  .showcase-invert {
    transition: all .5s;
    padding: 15px;
    border-radius: 5px;
    border: none;
    //box-shadow: 1px 1px 2px rgba(255,255,255,0.05), 1px 1px 2px rgba(0,0,0, .5) !important
    //box-shadow: 5px 5px 5px rgba(255,255,255,0.05), 1px 1px 5px rgba(0,0,0, .5) !important;
    -webkit-box-shadow: 0 1px 4px 0 rgba(0,0,0,.14);
    box-shadow: 0 1px 4px 0 rgba(0,0,0,.14);
  }

  .brand-header {
    box-shadow: 5px 5px 5px rgba(255,255,255,0.05), 2px 2px 5px rgba(0,0,0, .5) !important;
    padding: 10px;
    border-radius: 5px;
    background: linear-gradient(60deg,#26c6da,#00acc1);
    &:hover {
        transform: translate(0, -10px);
    }
  }

</style>